var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGovAiLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 25,
    viewBox: "0 0 105 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_763_1957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.2841 1.11536L75.8555 24.3319L80.6798 24.36L82.394 19.3465L90.3583 19.3923L92.0477 24.4251L97.005 24.4537L88.8443 1.14182L84.2841 1.11536ZM83.8727 15.1248L86.4608 7.60482L88.9287 15.154L83.8727 15.1248Z",
    fill: "#2C3F54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6359 17.9643L55.0485 1.14403L50.0918 1.11536L58.2524 24.4278L62.8127 24.4543L71.2413 1.23776L66.4164 1.20964L60.6359 17.9643Z",
    fill: "#2C3F54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9653 1.34032L99.832 24.4727L104.624 24.5003L104.757 1.36792L99.9653 1.34032Z",
    fill: "#2C3F54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3264 0.5C31.7741 0.5 26.4629 5.81177 26.4629 12.3635C26.4629 18.9153 31.7747 24.2271 38.3264 24.2271C44.8782 24.2271 50.19 18.9153 50.19 12.3635C50.19 5.81177 44.8787 0.5 38.3264 0.5ZM38.3264 19.8383C34.205 19.8383 30.8517 16.4849 30.8517 12.3635C30.8517 8.24215 34.205 4.8888 38.3264 4.8888C42.4478 4.8888 45.8012 8.24215 45.8012 12.3635C45.8012 16.4849 42.4478 19.8383 38.3264 19.8383Z",
    fill: "#2C3F54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9704 10.4277L12.9293 10.4161V14.58L18.9975 14.5965C18.0459 17.6306 15.2081 19.8383 11.8635 19.8383C7.74215 19.8383 4.3888 16.4849 4.3888 12.3635C4.3888 8.24215 7.74215 4.8888 11.8635 4.8888C13.5171 4.8888 15.0454 5.42968 16.2849 6.34217L18.2119 2.33988C16.3764 1.17486 14.1991 0.5 11.8635 0.5C5.31177 0.5 0 5.81177 0 12.3635C0 18.9153 5.31177 24.2271 11.8635 24.2271C18.4153 24.2271 23.6118 19.0289 23.7249 12.5742H23.7276V10.4415L14.9704 10.4156V10.4272V10.4277Z",
    fill: "#2C3F54"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_763_1957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.758,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovAiLogo);
export default __webpack_public_path__ + "static/media/gov-ai-logo.a2196d20ad7aa461655160b6171951af.svg";
export { ForwardRef as ReactComponent };